// extracted by mini-css-extract-plugin
export default {"routeSubtitle":"RouteSubtitle_routeSubtitle__SA9XX","appBarPath":"RouteSubtitle_appBarPath__Pzg0a","appBarSpliter":"RouteSubtitle_appBarSpliter__KAzqM"};